<template>
  <div
    :id="id"
    class="modal fade"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="id"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div slot="header">
            <div class="tag-badge">
              <span class="dot text-center">
                <i class="orange-icon orange-icon-badge-align fas fa-plus" />
              </span>
              <span class="tag-badge-title py-1 pl-2">
                Verificar información de contacto
              </span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <CustomInput label="Nombre:" />
              </div>
              <div class="col">
                <CustomDropDown
                  required
                  :options="[]"
                  fieldkey="id"
                  fieldname="name"
                  label="Parentesco:"
                  placeholder=""
                  class="w-100 d-inline-block ml-2"
                />
              </div>
            </div>
            <div class="row separator">
              <div class="col">
                <CustomInput label="Correo Electrónico:" />
              </div>
              <div class="col">
                <div class="input-group mt-4" style="margin-left:-13px;">
                  <div class="col-md-1" style="margin-right:19px;">
                    <input
                      id="chkNoAdminEmail"
                      type="checkbox"
                      class="option-input checkbox"
                    />
                    <label
                      for="chkNoAdminEmail"
                      class="checkbox-label pl-3 pr-4"
                    >
                      <span v-if="info.chkNoAdminEmail != null">
                        <i class="ic-check" />
                      </span>
                    </label>
                  </div>
                  <div class="col-md-10">
                    No desea administrar un correo electrónico
                  </div>
                </div>
              </div>
            </div>
            <div class="row separator">
              <div class="col">
                <CustomInput label="Teléfono:" />
              </div>
              <div class="col mt-2">
                <div class="input-group mt-3">
                  <label />
                  <input
                    id="chkReceiveEmail"
                    type="checkbox"
                    class="option-input checkbox"
                  />
                  <label for="chkReceiveEmail" class="checkbox-label pl-3 pr-4">
                    <span v-if="info.chkReceiveEmail != null">
                      <i class="ic-check" />
                    </span>
                    Desea recibir mensajes de texto
                  </label>
                </div>
              </div>
            </div>
            <div class="row ml-n2 separator">
              <div class="col">
                <CustomDropDown
                  required
                  :options="[]"
                  fieldkey="id"
                  fieldname="name"
                  label="Proveedor:"
                  placeholder=""
                  class="w-100 d-inline-block ml-2"
                />
              </div>
              <div class="col" />
            </div>

            <div class="row">
              <div class="col text-right">
                <ActionButton
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger m-2"
                  data-dismiss="modal"
                  @click="cancel"
                >
                  Cancelar
                </ActionButton>
                <ActionButton variant="success m-2 pl-4 pr-4" @click="save">
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/component/checkbox.css';
import { CustomInput, CustomDropDown, ActionButton } from '@/components/common';
export default {
  name: 'VerifyContactInformationPopup',
  data() {
    return {
      info: {
        chkNoAdminEmail: false,
        chkReceiveEmail: false,
      },
    };
  },
  props: {
    id: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    cancel() {},
    save() {},
  },
  components: {
    CustomInput,
    CustomDropDown,
    ActionButton,
  },
};
</script>

<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 17px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

.modal-header {
  padding: 0.5rem 0rem 0rem 1.5rem;
  box-shadow: 0px 10px 40px -20px black;
}
.cursor-pointer {
  cursor: pointer;
}

.separator {
  margin-top: 40px;
}
</style>
